<template>
  <div class="fcf-main">
    <b-collapse class="panel" :open.sync="isOpen">

      <panel-heading slot="trigger" :title="'File Details'" :editNotAllowed="editNotAllowed"/>

      <div class="panel-block fcf-main__content">
        <div class="fcf-main__row fcf-main__row--1" v-if="!editNotAllowed">
          <div class="buttons is-right">
            <button class="button" @click="updateData">
              <b-icon icon="refresh"/>
              <span>Refresh data from WFM</span>
            </button>
          </div>
        </div>

        <div class="fcf-main__row">
          <div>Name of client</div>
          <div>
            <fcf-field
              :name="'clientName'"
              :value="jobData.clientName"
              :type="'text'"
              :edit-not-allowed="editNotAllowed"
              @value-changed="onValueChanged"
            />
          </div>
        </div>
        <div class="fcf-main__row">
          <div>Workflowmax no.</div>
          <div>
            <fcf-field
              :name="'jobNumber'"
              :value="jobData.jobNumber"
              :type="'text'"
              :edit-not-allowed="editNotAllowed"
              @value-changed="onValueChanged"
            />
          </div>
        </div>
        <div class="fcf-main__row">
          <div>Client no.</div>
          <div>
            <fcf-field
              :name="'clientNumber'"
              :value="jobData.clientNumber"
              :type="'text'"
              :edit-not-allowed="editNotAllowed"
              @value-changed="onValueChanged"
            />
          </div>
        </div>
        <div class="fcf-main__row">
          <div>Matter no.</div>
          <div>
            <fcf-field
              :name="'matterNumber'"
              :value="jobData.matterNumber"
              :type="'text'"
              :edit-not-allowed="editNotAllowed"
              @value-changed="onValueChanged"
            />
          </div>
        </div>
        <div class="fcf-main__row">
          <div>Matter name</div>
          <div>
            <fcf-field
              :name="'matterName'"
              :value="jobData.matterName"
              :type="'text'"
              :edit-not-allowed="editNotAllowed"
              @value-changed="onValueChanged"
            />
          </div>
        </div>
        <div class="fcf-main__row">
          <div>Date of file opened</div>
          <div>
            <fcf-field
              :name="'dateOpened'"
              :value="jobData.dateOpened ? new Date(jobData.dateOpened) : null"
              :type="'date'"
              :edit-not-allowed="editNotAllowed"
              @value-changed="onValueChanged"
            />
          </div>
        </div>
        <div class="fcf-main__row">
          <div>Date of file closed</div>
          <div>
            <fcf-field
              :name="'dateClosed'"
              :value="jobData.dateClosed ? new Date(jobData.dateClosed) : null"
              :type="'date'"
              :edit-not-allowed="editNotAllowed"
              @value-changed="onValueChanged"
            />
          </div>
        </div>
        <div class="fcf-main__row">
          <div>Lawyers and paralegals involved</div>
          <div>
            <ul>
              <li v-for="(staff, idx) in jobData.staff" :key="staff.id">
                <b-tag size="is-medium" :closable="!editNotAllowed" @close="removeStaff(idx)">
                  <span>{{staff.name}}</span>
                </b-tag>
              </li>
            </ul>
            <b-field v-if="!editNotAllowed">
              <b-select placeholder="Add person" v-model="addPersonChoice">
                <option
                    v-for="person in staff"
                    :value="person.id"
                    :key="person.id">
                    {{ person.name }}
                </option>
              </b-select>
              <p class="control">
                <button class="button" @click="addStaff">Add</button>
              </p>
            </b-field>
          </div>
        </div>
        <div class="fcf-main__row">
          <div>Secretary</div>
          <div>
            <fcf-field
              :name="'secretary'"
              :value="jobData.secretary"
              :type="'text'"
              :edit-not-allowed="editNotAllowed"
              @value-changed="onValueChanged"
            />
            </div>
        </div>
        <div class="fcf-main__row">
          <div>Approved by</div>
          <div>
            <b-field>
              <b-select placeholder="Choose person" v-model="jobData.approvedBy" :disabled="editNotAllowed">
                <option
                    v-for="person in staff"
                    :value="person.id"
                    :key="person.id">
                    {{ person.name }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div class="fcf-main__row">
          <div>Bible no.</div>
          <div>
            <fcf-field
              :name="'bibleNumber'"
              :value="jobData.bibleNumber"
              :type="'text'"
              :edit-not-allowed="editNotAllowed"
              @value-changed="onValueChanged"
            />
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import FcfField from '@/components/FcfField'
import PanelHeading from '@/components/PanelHeading'

export default {
  name: 'FcfMain',
  components: {
    FcfField,
    PanelHeading
  },
  props: ['jobData', 'editNotAllowed'],
  data () {
    return {
      isOpen: true,
      addPersonChoice: null,
      staff: []
    }
  },
  created () {
    this.getStaff()
  },
  methods: {
    updateData () {
      this.$emit('update-job-data')
    },
    onValueChanged (edit) {
      this.$emit('value-changed', edit)
      this.$emit('form-changed')
    },
    removeStaff (idx) {
      if (!this.jobData) return
      this.$delete(this.jobData.staff, idx)
      this.$emit('form-changed')
    },
    addStaff () {
      const newStaff = this.staff.find(staff => {
        if (staff.id === this.addPersonChoice) return true
      })
      if (newStaff === undefined) return

      if (!this.jobData.staff) this.$set(this.jobData, 'staff', [])

      const allStaffIds = this.jobData.staff.map(staff => staff.id)

      if (allStaffIds.indexOf(newStaff.id) > -1) {
        this.$toast.open('Already in the list')
        this.addPersonChoice = null
        return
      }

      this.jobData.staff.push(newStaff)
      this.addPersonChoice = null
    },
    getStaff () {
      this.axios.get('wfm/staff')
        .then(response => {
          this.staff = response.data
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped>

li {
  padding-bottom: 0.5em;
}

.fcf-main__header {
  display: grid;
  grid-column: 1/-1;
  grid-template-columns: 1fr;
}

.fcf-main__content {
  display: grid;
  grid-column: 1/-1;
  grid-gap: 1em;
  grid-template-columns: 1fr;
}

.fcf-main__row {
  display: grid;
  grid-column: 1/-1;
  grid-gap: 1em;
  grid-template-columns: 0.5fr 0.5fr;
}

.fcf-main__row--1 {
  grid-template-columns: 1fr;
}

</style>
